export enum ServiceEnum {
  Service = 'SERVICE'
}

export enum ServiceEnumApi {
  service = 'services/'
}
